import confetti from "canvas-confetti";

export function fireConfetti() {
  const colors = ["#22d3ee", "#a855f7", "#ec4899", "#fbbf24", "#34d399", "#ffffff"];
  const end = Date.now() + 1200;

  confetti({
    particleCount: 140,
    spread: 90,
    startVelocity: 55,
    origin: { y: 0.6 },
    colors,
    scalar: 1.1,
    zIndex: 10001,
  });

  (function frame() {
    confetti({
      particleCount: 6,
      angle: 60,
      spread: 70,
      origin: { x: 0, y: 0.7 },
      colors,
      zIndex: 10001,
    });
    confetti({
      particleCount: 6,
      angle: 120,
      spread: 70,
      origin: { x: 1, y: 0.7 },
      colors,
      zIndex: 10001,
    });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
}

export function fireFireworks(durationMs = 2200) {
  const end = Date.now() + durationMs;
  const colors = ["#22d3ee", "#a855f7", "#ec4899", "#fbbf24"];
  (function loop() {
    confetti({
      particleCount: 70,
      startVelocity: 38,
      spread: 360,
      ticks: 70,
      origin: { x: Math.random(), y: Math.random() * 0.5 + 0.1 },
      colors,
      shapes: ["circle", "square"],
      scalar: 1,
      zIndex: 10001,
    });
    if (Date.now() < end) setTimeout(loop, 320);
  })();
}
